import React from 'react';
import {Table} from '../../../components/table/Table';
import {
  Linking,
  Text,
  TouchableOpacity,
} from '@unthinkable/react-core-components';
import {useInvoke} from '../../../controllers/useInvoke';

const RenderName = props => {
  const {row, styles = {}} = props;
  const {rowText} = styles;
  let {website = ''} = row || {};
  const underline = website ? {textDecoration: 'underline'} : void 0;

  website =
    website && (website.startsWith('https') ? website : `https://${website}`);

  return (
    <TouchableOpacity
      onPress={() => {
        website && Linking.openURL(website, '_blank');
      }}>
      <Text
        style={{
          ...rowText,
          ...underline,
        }}>
        {website}
      </Text>
    </TouchableOpacity>
  );
};

export const UserSegmentProspectList = props => {
  let {
    route: {params},
    navigation,
  } = props;

  const invokePost = useInvoke({
    method: 'post',
    eventSourceId: ['removeProspect'],
  });

  let {user_segment_id} = params || {};
  return (
    <Table
      {...props}
      selection={{
        actions: [
          {
            title: 'Delete',
            variant: 'error',
            confirm: {
              title: 'Delete',
              message: 'Are you sure you want to Delete?',
              confirmText: 'Delete',
            },
            onPress: ({selectedIds}) => {
              invokePost({
                uri: `/delete-selected-prospects`,
                props: {
                  selectedIds,
                },
              });
            },
          },
        ],
      }}
      api={`/potentialcustomers`}
      filter={{user_segment_id}}
      eventSourceId={'removeProspect'}
      fields={{
        name: 1,
        email: 1,
        website: 1,
        createdAt: 1,
      }}
      sort={{createdAt: -1}}
      columns={[
        {
          type: 'text',
          header: 'Prospect',
          field: 'name',
        },
        {
          type: 'text',
          render: RenderName,
          header: 'Website',
        },
        {
          type: 'text',
          header: 'Email',
          field: 'email',
        },
        {
          type: 'date',
          header: 'Date',
          field: 'createdAt',
        },
      ]}
      moreActions={[
        {
          title: 'Delete',
          variant: 'error',
          confirm: {
            title: 'Delete',
            message: 'Are you sure you want to Delete?',
            confirmText: 'Delete',
          },
          onPress: ({row}) => {
            invokePost({
              uri: `/delete-prospects`,
              props: {
                _id: row?._id,
              },
            });
          },
        },
      ]}
    />
  );
};
